import { motion } from 'framer-motion';

/**
 * Reveal
 * Wraps any block of content and animates it in once it scrolls into view.
 * This is the shared building block behind every "box animates in on scroll"
 * moment across the page (hero copy, promo cards, cta panel, footer columns).
 *
 * Props:
 *  - as: 'up' | 'left' | 'right' | 'scale'  (direction of the entrance)
 *  - delay: number (seconds, for staggering a group of items)
 *  - duration: number (seconds)
 *  - className: passed through to the wrapping element
 */
const OFFSETS = {
  up: { y: 28, x: 0 },
  down: { y: -28, x: 0 },
  left: { y: 0, x: 28 },
  right: { y: 0, x: -28 },
  scale: { y: 12, x: 0 },
};

export default function Reveal({
  children,
  as = 'up',
  delay = 0,
  duration = 0.6,
  className,
  once = true,
  amount = 0.3,
}) {
  const offset = OFFSETS[as] || OFFSETS.up;
  const initial = {
    opacity: 0,
    y: offset.y,
    x: offset.x,
    scale: as === 'scale' ? 0.94 : 1,
  };

  return (
    <motion.div
      className={className}
      initial={initial}
      whileInView={{ opacity: 1, y: 0, x: 0, scale: 1 }}
      viewport={{ once, amount }}
      transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}
